import { all, call, put, takeLatest, select } from "redux-saga/effects"
import API from "../../helpers/sagaApi/sagaApi"
import Actions, { SagaBookingTypes } from "./sagaBookingRedux"
import CartActions from "../sagaCart/sagaCartRedux"
import AuthActions from "../sagaAuth/sagaAuthRedux"
import { getJwtToken } from "../sagaAuth/sagaAuthSaga"
import { currentLanguageRfc3066Fnc } from "../languageSwitcher/languageSwitcherSaga"
import AppConfig from "../../configs/AppConfig"
import { push } from "react-router-redux"
import { effects } from "redux-saga"
import { buildUrl, confirmClearCart, messageInfo } from "../../helpers/utility"

export function* requestGetInitialBooking(action) {
  const tag = "[REQUEST_GET_INITIAL_BOOKING]"
  try {
    // step 2 : validation passed..
    const response = yield call(API.requestGetInitialBooking)
    if (response.status === 200 && response.data.statusCode === 200) {
      if (AppConfig.isDevelopment) {
        console.log(`${tag} requestGetInitialBooking response :`, response.data)
      }
      yield put(Actions.getInitialBookingSuccess(response.data.result))
    } else {
      throw new Error(response.data.error)
    }
  } catch (e) {
    console.warn(`${tag} requestGetInitialBooking failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.getInitialBookingFailure(message))
  }
}

export function* requestGetInitialBookingDetail(action) {
  const tag = "[REQUEST_GET_INITIAL_BOOKING_DETAIL]"
  try {
    // step 2 : validation passed..
    const response = yield call(
      API.requestGetInitialBookingDetail,
      action.bookingDetail
    )
    if (response.status === 200 && response.data.statusCode === 200) {
      if (AppConfig.isDevelopment) {
        console.log(
          `${tag} requestGetInitialBookingDetail response :`,
          response.data
        )
      }
      // yield put(CartActions.requestClearCar())
      yield put(Actions.getInitialBookingDetailSuccess(response.data.result))
    } else {
      throw new Error(response.data.error)
    }
  } catch (e) {
    console.warn(`${tag} requestGetInitialBookingDetail failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.getInitialBookingDetailFailure(message))
  }
}

export function* requestCreateBooking(action) {
  const tag = "[REQUEST_CREATE_BOOKING]"
  try {
    // step 1: perform input validation
    const jwtToken = yield getJwtToken()
    const culture = yield select(currentLanguageRfc3066Fnc)
    if (jwtToken) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestCreateBooking,
        jwtToken,
        culture,
        action.bookingTrip,
        action.routeItems,
        action.selectedBusTypes,
        action.userId
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(`${tag} requestCreateBooking response :`, response.data)
        }
        yield put(Actions.createBookingSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("Not logged in.") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestCreateBooking failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.createBookingFailure(message))
  }
}

export function* requestUpdateBooking(action) {
  const tag = "[REQUEST_UPDATE_BOOKING]"
  try {
    // step 1: perform input validation
    const jwtToken = yield getJwtToken()
    const culture = yield select(currentLanguageRfc3066Fnc)
    if (jwtToken) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestUpdateBooking,
        jwtToken,
        culture,
        action.bookingTrip,
        action.routeItems,
        action.selectedBusTypes,
        action.userId
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(`${tag} requestUpdateBooking response :`, response.data)
        }
        yield put(Actions.updateBookingSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("Not logged in.") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestUpdateBooking failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.updateBookingFailure(message))
  }
}

export function* requestGetBookingDetail(action) {
  const tag = "[REQUEST_GET_BOOKING_DETAIL]"
  try {
    // step 1: perform input validation
    const jwtToken = yield getJwtToken()
    if (jwtToken) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestGetBookingDetail,
        jwtToken,
        action.id,
        action.userId
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(
            `${tag} requestGetBookingDetail response :`,
            response.data
          )
        }
        yield put(Actions.getBookingDetailSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("Not logged in") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestGetBookingDetail failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.getBookingDetailFailure(message))
  }
}

export function* requestGetQuotationDetail(action) {
  const tag = "[REQUEST_GET_QUOTATION_DETAIL]"
  try {
    // step 1: perform input validation
    const jwtToken = yield getJwtToken()
    const culture = yield select(currentLanguageRfc3066Fnc)
    if (jwtToken) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestGetQuotationDetail,
        jwtToken,
        action.id,
        culture
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(
            `${tag} requestGetQuotationDetail response :`,
            response.data
          )
        }
        yield put(Actions.getQuotationDetailSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("Not logged in") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestGetQuotationDetail failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.getQuotationDetailFailure(message))
  }
}

export function* requestGetPaymentDetail(action) {
  const tag = "[REQUEST_GET_PAYMENT_DETAIL]"
  try {
    // step 1: perform input validation
    const jwtToken = yield getJwtToken()
    const culture = yield select(currentLanguageRfc3066Fnc)
    if (jwtToken) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestGetPaymentDetail,
        jwtToken,
        culture,
        action.id,
        action.userId
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(
            `${tag} requestGetPaymentDetail response :`,
            response.data
          )
        }
        yield put(Actions.getPaymentDetailSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("Not logged in") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestGetPaymentDetail failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.getPaymentDetailFailure(message))
  }
}
export function* requestGetHisobusMybooking(action) {
  const tag = "[REQUEST_GET_HISOBUS_MYBOOKING]"
  try {
    // step 1: perform input validation
    const jwtToken = yield getJwtToken()
    if (jwtToken) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestGetHisobusMybooking,
        jwtToken,
        action.userId
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(
            `${tag} requestGetHisobusMybooking response :`,
            response.data
          )
        }
        yield put(Actions.getHisobusMybookingSuccess(response.data.result))
        yield put(AuthActions.requestClearUpdateUserProfileStatus())
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("Not logged in") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestGetHisobusMybooking failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.getHisobusMybookingFailure(message))
  }
}

export function* requestSendQuotation(action) {
  const tag = "[REQUEST_SEND_QUOTATION]"
  try {
    // step 1: perform input validation
    const jwtToken = yield getJwtToken()
    const culture = yield select(currentLanguageRfc3066Fnc)
    if (jwtToken) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestSendQuotation,
        jwtToken,
        action.userId,
        action.id,
        culture
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(`${tag} requestSendQuotation response :`, response.data)
        }
        yield put(Actions.sendQuotationSuccess(response.data.result))
        confirmClearCart(
          "successfully",
          culture === "th"
            ? "ระบบกำลังใบเสนอราคาไปที่ email ของคุณ"
            : "ระบบกำลังใบเสนอราคาไปที่ email ของคุณ"
        )
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestSendQuotation failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.sendQuotationFailure(message))
  }
}

export function* requestUpdateMyBookingTransaction(action) {
  const tag = "[REQUEST_UPDATE_MY_BOOKING_TRANSACTION]"
  try {
    // step 1: perform input validation
    const jwtToken = yield getJwtToken()
    if (jwtToken) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestUpdateMyBookingTransaction,
        jwtToken,
        action.bookingTransaction
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(
            `${tag} requestUpdateMyBookingTransaction response :`,
            response.data
          )
        }
        yield put(
          Actions.updateMyBookingTransactionSuccess(response.data.result)
        )
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(
      `${tag} requestUpdateMyBookingTransaction failed with error :`,
      e
    )
    const message = e.message ? e.message : "Failed"
    yield put(Actions.updateMyBookingTransactionFailure(message))
  }
}

export function* requestGetPriceCompare(action) {
  const tag = "[REQUEST_GET_PRICE_COMPARE]"
  try {
    // step 1: perform input validation
    const inputValid = true // IDE-Help, do not delete me
    if (inputValid) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestGetPriceCompare,
        action.bookingDetail
      )
      // console.log("dddddddddddddddddd", response)
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(`${tag} requestGetPriceCompare response :`, response.data)
        }
        yield put(Actions.getPriceCompareSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestGetPriceCompare failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.getPriceCompareFailure(message))
  }
}

export function* requestCreateCarBooking(action) {
  console.log("action value in requestCreateCarBooking", action)
  const tag = "[REQUEST_CREATE_CAR_BOOKING_]"
  try {
    // step 1: perform input validation
    const jwtToken = yield getJwtToken()
    const culture = yield select(currentLanguageRfc3066Fnc)
    if (jwtToken) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestCreateBookingV2,
        jwtToken,
        action.booking
      )
      console.log("response from requestCreateBookingV2", response)
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(
            `${tag} requestCreateCarBooking response :`,
            response.data
          )
        }
        yield put(Actions.createCarBookingSuccess(response.data.result))
        if (response.data.result !== null || response.data.result !== 0) {
          yield put(CartActions.requestClearCart())
          yield effects.put(
            push(`/${culture}/bookingPayment/${response.data.result}`)
          )
        }
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestCarCreateBooking failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.createCarBookingFailure(message))
  }
}

export function* requestCheckBookingPrice(action) {
  const tag = "[REQUEST_CHECK_BOOKING_PRICE]"
  try {
    const jwtToken = yield getJwtToken()
    if (jwtToken) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestCheckBookingPrice,
        jwtToken,
        action.userId,
        action.bookingId
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(
            `${tag} requestCheckBookingPrice response :`,
            response.data
          )
        }
        yield put(Actions.checkBookingPriceSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestCheckBookingPrice failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.checkBookingPriceFailure(message))
  }
}

export function* requestGetPromotionByPromoCode(action) {
  const tag = "[REQUEST_GET_PROMOTION_BY_PROMO_CODE]"
  try {
    const culture = yield select(currentLanguageRfc3066Fnc)
    const jwtToken = yield getJwtToken()
    if (jwtToken) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestGetPromotionByPromoCode,
        jwtToken,
        action.code
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(
            `${tag} requestGetPromotionByPromoCode response :`,
            response.data
          )
        }
        yield put(Actions.getPromotionByPromoCodeSuccess(response.data.result))
        if (response.data.result === "invaliddate") {
          messageInfo(
            "PROMOTION CODE !!",
            culture === "th"
              ? "ไม่สามารถใช้โปรโมชั่นโค้ดได้ เนื่องจากอยู่นอกช่วงเวลาที่กำหนด"
              : "Can't use promotion code."
          )
        } else {
          confirmClearCart(
            "PROMOTION CODE !!",
            culture === "th"
              ? response.data.result.thaiTitle
              : response.data.result.engTitle
          )
        }
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestGetPromotionByPromoCode failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.getPromotionByPromoCodeFailure(message))
  }
}

export function* requestGetTripObjects(action) {
  const tag = "[REQUEST_GET_TRIP_OBJECTS]"
  try {
    const jwtToken = yield getJwtToken()
    if (jwtToken) {
      const response = yield call(API.requestGetTripObjects, jwtToken)
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(`${tag} requestGetTripObjects response :`, response.data)
        }
        yield put(Actions.getTripObjectsSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestGetTripObjects failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.getTripObjectsFailure(message))
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(
      SagaBookingTypes.REQUEST_GET_INITIAL_BOOKING,
      requestGetInitialBooking
    ),
    takeLatest(
      SagaBookingTypes.REQUEST_GET_INITIAL_BOOKING_DETAIL,
      requestGetInitialBookingDetail
    ),
    takeLatest(SagaBookingTypes.REQUEST_CREATE_BOOKING, requestCreateBooking),
    takeLatest(SagaBookingTypes.REQUEST_UPDATE_BOOKING, requestUpdateBooking),
    takeLatest(
      SagaBookingTypes.REQUEST_GET_BOOKING_DETAIL,
      requestGetBookingDetail
    ),
    takeLatest(
      SagaBookingTypes.REQUEST_GET_QUOTATION_DETAIL,
      requestGetQuotationDetail
    ),
    takeLatest(
      SagaBookingTypes.REQUEST_GET_PAYMENT_DETAIL,
      requestGetPaymentDetail
    ),
    takeLatest(
      SagaBookingTypes.REQUEST_GET_HISOBUS_MYBOOKING,
      requestGetHisobusMybooking
    ),
    takeLatest(SagaBookingTypes.REQUEST_SEND_QUOTATION, requestSendQuotation),
    takeLatest(
      SagaBookingTypes.REQUEST_UPDATE_MY_BOOKING_TRANSACTION,
      requestUpdateMyBookingTransaction
    ),
    takeLatest(
      SagaBookingTypes.REQUEST_GET_PRICE_COMPARE,
      requestGetPriceCompare
    ),
    takeLatest(
      SagaBookingTypes.REQUEST_CREATE_CAR_BOOKING,
      requestCreateCarBooking
    ),
    takeLatest(
      SagaBookingTypes.REQUEST_CHECK_BOOKING_PRICE,
      requestCheckBookingPrice
    ),

    takeLatest(
      SagaBookingTypes.REQUEST_GET_PROMOTION_BY_PROMO_CODE,
      requestGetPromotionByPromoCode
    ),
    takeLatest(SagaBookingTypes.REQUEST_GET_TRIP_OBJECTS, requestGetTripObjects)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagaBooking/sagaBookingSaga.ts